import React from 'react';
import { motion } from 'framer-motion';
import { useContent } from '../../lib/content';
import { pickLocale } from '../../lib/api';

export default function Manifesto() {
  const { content, locale } = useContent();
  const data = content.manifesto || {};
  const intro = pickLocale(data.intro, locale, '');
  const body = pickLocale(data.body, locale, '');
  const highlights = (data.highlights || []).map((h) => pickLocale(h, locale));

  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="section bg-bg relative"
    >
      <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
        <div className="md:col-span-3">
          <p className="text-eyebrow mb-4">{pickLocale(data.eyebrow, locale)}</p>
          <p className="text-eyebrow text-ink-dim">{pickLocale(data.context_label, locale)}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
          className="md:col-span-9"
          data-testid="manifesto-text"
        >
          <p className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.1] text-ink-muted">
            <span className="text-ink">{intro}</span>{' '}
            {highlights.map((h, i) => (
              <span key={i}>
                <span className="font-display italic text-acid">{h}</span>
                {i < highlights.length - 1 ? <span className="text-ink-muted">{', '}</span> : <span className="text-ink-muted">{'.'}</span>}
                {' '}
              </span>
            ))}
            {body && (
              <>
                <br />
                <br />
                <span className="text-ink-muted">{body}</span>
              </>
            )}
          </p>

          {(data.signature_text || data.signature_image) && (
            <div className="mt-12 flex items-center gap-4">
              {data.signature_image ? (
                <img loading="lazy" decoding="async" src={data.signature_image} alt="signature" className="h-14 md:h-20" />
              ) : (
                <span className="signature-acid">{data.signature_text || 'MODARIA'}</span>
              )}
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
